import React, { useState } from 'react'
import Breadcrumbs from '../../common/breadcrumb/Breadcrumbs';
import { Formik,Form, Field } from 'formik';
import CustomInputField from '../../common/CustomInputField';
import { Button } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import Loadar from '../../common/loader/Loader';
import { message } from 'antd';
import { getnumberlogstatus } from '../../api/login/Login';

const CheckNumberLog = () => {

    const breadCrumbsTitle = {
        id: "1",
        title_1: 'Number Logs',
        title_2: 'Check Number Log',
      };
       const [key, setKey] = useState(0); 
       const [apiResponse , setApiResponse] = useState([])
        const [loading, setLoading] = useState(false);
       const [initialValues, setInitialValues] = useState({
        numLog: "",
        });


      const submitForm = async(values)=> {
        setLoading(true);

        try {
            let res = await getnumberlogstatus(values?.numLog)
            
            if (res?.statusCode === 200) {
                setApiResponse(res?.data)
              } else {
                setApiResponse([])
                message.info('No data available');
                
              }
            
        } catch (error) {
            message.error('Failed to fetch transaction data. Please try again.');
        } finally{
            setLoading(false)
        }
      }  

      function validateLength(value) {
        let error;
        if (value?.length <=5) {
          error = 'Minimum 6 Character Required';
        }
        return error;
      }
  return (
   <>
   {loading && <Loadar />}
    <Breadcrumbs breadCrumbsTitle={breadCrumbsTitle} />
    <div className="row m-4">
            <div className="col-xl-12">
                <div className="card">
                    <div className="card-body p-0">
                        <div className="table-responsive active-projects style-1">
                            <div className="tbl-caption tbl-caption-2">
                                <h4 className="heading mb-0"><b>{'Check Number log'} </b></h4>
                            </div>
                            <Formik
                                key={key} // Add this line
                                initialValues={initialValues}
                                onSubmit={submitForm}
                                enableReinitialize
                            >
                                {({ values, handleChange, handleSubmit, resetForm, errors, touched, handleBlur, setFieldValue }) => (
                                    <Form className="tbl-captionn">
                                        <div className="row">
                                          
                                         
                                         
                                            <div className="col-xl-5 mb-3">
                                                <Field
                                                    validate={validateLength}
                                                    as={CustomInputField}
                                                    type="text"
                                                    placeholder="Log Number"
                                                    name="numLog"
                                                    
                                                    hasError={errors.numLog && touched.numLog}
                                                    errorMsg={errors.numLog}
                                                />
                                               
                                            </div>
                                           
                                         
                                        
                                            <div className="col-lg-4 col-md-4">
                                                <div className='d-flex justify-content-start'>
                                                    <Button 
                                                        className="btn btn-primary pd-x-20 me-2" 
                                                        type="submit"
                                                    >
                                                        <i className="fas fa-search"></i> Search
                                                    </Button>
                                                    {/* <Button 
                                                        className="btn btn-secondary pd-x-20" 
                                                        type="button" 
                                                      
                                                    >
                                                        <i className="fas fa-refresh"></i> Reset
                                                    </Button> */}
                                                </div>
                                            </div>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                            </div>
                            </div>
                            </div>
                            </div>
                            </div>




                            <div className="row m-4">
            <div className="col-xl-12">
                <div className="card">
                    <div className="card-body p-0">

                      {apiResponse?.length>0 ?
                       <>
                     <div className="table-responsive active-projects style-1">
                     <div className="tbl-caption tbl-caption-2">
                         <h4 className="heading mb-0"><b>{apiResponse?.length >0 && apiResponse[0]?.req_url} </b></h4>
                     </div>
                       {apiResponse?.map((item )=>
<div className="row">
                                   
                                  
                                  
                                   <div className="col-6 mb-3">

                                   <Card style={{ width: '100%' }}>

<Card.Body>
<Card.Title>Body</Card.Title>

</Card.Body>
<ListGroup className="list-group-flush"  style={{maxHeight:'300px' ,height:'300px'}}>



<pre style={{fontSize:'18px'}}>
    {JSON.stringify(item?.req_body ,  null, 4)}
</pre>

</ListGroup>


</Card>
</div>
<div className="col-6 mb-3">

<Card style={{ width: '100%' }}>

<Card.Body>
 <Card.Title>Response</Card.Title>

</Card.Body>
<ListGroup className="list-group-flush" style={{maxHeight:'300px' , height:'300px'}}>
<pre style={{fontSize:'18px'}}>
    {JSON.stringify(item?.response ,  null, 4)}
</pre>
</ListGroup>

</Card>
</div>
                    
                   
                     </div>
                      )}
                     </div>
                   
                      
                      </> :
                      <>
                      <p className=' text-center'>No Data found</p>
                      </>}

                       


                            </div>
                            </div>
                            </div>
                            </div>
   
   </>
  )
}

export default CheckNumberLog
